"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectorLocationWrapper$ = exports.SectorLocationWrapper$outboundSchema = exports.SectorLocationWrapper$inboundSchema = void 0;
exports.sectorLocationWrapperToJSON = sectorLocationWrapperToJSON;
exports.sectorLocationWrapperFromJSON = sectorLocationWrapperFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const sectorlocationattributes_js_1 = require("./sectorlocationattributes.js");
/** @internal */
exports.SectorLocationWrapper$inboundSchema = z.object({
    attributes: sectorlocationattributes_js_1.SectorLocationAttributes$inboundSchema,
    id: z.string(),
    type: z.literal("sector").default("sector").optional(),
});
/** @internal */
exports.SectorLocationWrapper$outboundSchema = z.object({
    attributes: sectorlocationattributes_js_1.SectorLocationAttributes$outboundSchema,
    id: z.string(),
    type: z.literal("sector").default("sector"),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var SectorLocationWrapper$;
(function (SectorLocationWrapper$) {
    /** @deprecated use `SectorLocationWrapper$inboundSchema` instead. */
    SectorLocationWrapper$.inboundSchema = exports.SectorLocationWrapper$inboundSchema;
    /** @deprecated use `SectorLocationWrapper$outboundSchema` instead. */
    SectorLocationWrapper$.outboundSchema = exports.SectorLocationWrapper$outboundSchema;
})(SectorLocationWrapper$ || (exports.SectorLocationWrapper$ = SectorLocationWrapper$ = {}));
function sectorLocationWrapperToJSON(sectorLocationWrapper) {
    return JSON.stringify(exports.SectorLocationWrapper$outboundSchema.parse(sectorLocationWrapper));
}
function sectorLocationWrapperFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.SectorLocationWrapper$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'SectorLocationWrapper' from JSON`);
}
//# sourceMappingURL=sectorlocationwrapper.js.map